import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Equipment Module Service Stores
 * Updated to match backend api-types
 */
export const equipmentStores: ServiceStoreConfig[] = [
  {
    name: "equipment-calibrations",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        summaryCards: (rootStore) => {
          const store = rootStore.equipmentCalibrationsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalCalibrations = entities.length;
          const passed = entities.filter(
            (cal: Record<string, unknown>) => cal.result === "pass" || cal.result === "passed"
          ).length;
          const failed = entities.filter(
            (cal: Record<string, unknown>) => cal.result === "fail" || cal.result === "failed"
          ).length;
          const dueSoon = entities.filter((cal: Record<string, unknown>) => {
            if (!cal.nextCalibrationDue) return false;
            const dueDate = new Date(cal.nextCalibrationDue as string);
            const now = new Date();
            const thirtyDaysFromNow = new Date();
            thirtyDaysFromNow.setDate(now.getDate() + 30);
            return dueDate <= thirtyDaysFromNow;
          }).length;

          return [
            {
              title: "Total Calibrations",
              value: () => totalCalibrations.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Passed",
              value: () => passed.toString(),
              valueColor: "success.main",
            },
            {
              title: "Failed",
              value: () => failed.toString(),
              valueColor: "error.main",
            },
            {
              title: "Due Soon",
              value: () => dueSoon.toString(),
              valueColor: "warning.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "equipment-daily-inspection",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        summaryCards: (rootStore) => {
          const store = rootStore.equipmentDailyInspectionStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalInspections = entities.length;
          const passed = entities.filter(
            (inspection: Record<string, unknown>) => inspection.result === "pass" || inspection.result === "passed"
          ).length;
          const failed = entities.filter(
            (inspection: Record<string, unknown>) => inspection.result === "fail" || inspection.result === "failed"
          ).length;
          const today = entities.filter((inspection: Record<string, unknown>) => {
            const inspDate = new Date(inspection.inspectionDate as string);
            const now = new Date();
            return inspDate.toDateString() === now.toDateString();
          }).length;

          return [
            {
              title: "Total Inspections",
              value: () => totalInspections.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Passed",
              value: () => passed.toString(),
              valueColor: "success.main",
            },
            {
              title: "Failed",
              value: () => failed.toString(),
              valueColor: "error.main",
            },
            {
              title: "Today",
              value: () => today.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  // ── Plant Maintenance (BE 11) ────────────────────────────────────────────
  // Multi-tier PM schedules per equipment. Each row is a tier (e.g. "250hr")
  // with its own intervalHours/intervalDays + checklistJson template. Consumed
  // by src/views/plantMaintenance/PlantMaintenance.Body. Backend PK is `id`
  // (Type.Number in equipment-pm-schedules.schema.ts, no getOptions.id
  // override) so no idField is needed.
  {
    name: "equipment-pm-schedules",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
  // Work-order / maintenance log per equipment. Optionally linked to a PM tier
  // via pmScheduleId (null = unplanned/corrective). status is
  // open | in_progress | complete. Backend PK is `id` (no override needed).
  {
    name: "equipment-maintenance-entries",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
    },
  },
];
